import {
  DISABLE_USER,
  DISABLE_USER_SUCCESSFUL,
  DISABLE_USER_FAILED,
  ENABLE_USER,
  ENABLE_USER_SUCCESSFUL,
  ENABLE_USER_FAILED,
} from "./actionTypes";

const initialState = {
  disableError: null,
  disableMessage: null,
  loadingDisableUser: false,
  enableError: null,
  enableMessage: null,
  loadingEnableUser: false,
};

const statusUser = (state = initialState, action) => {
  switch (action.type) {
    case DISABLE_USER:
      state = {
        ...state,
        loadingDisableUser: true,
        disableError: null,
      };
      break;
    case DISABLE_USER_SUCCESSFUL:
      state = {
        ...state,
        loadingDisableUser: false,
        disableMessage: action.payload,
        disableError: null,
      };
      break;
    case DISABLE_USER_FAILED:
      state = {
        ...state,
        disableMessage: null,
        loadingDisableUser: false,
        disableError: action.payload,
      };
      break;
    case ENABLE_USER:
      state = {
        ...state,
        loadingEnableUser: true,
        enableError: null,
      };
      break;
    case ENABLE_USER_SUCCESSFUL:
      state = {
        ...state,
        loadingEnableUser: false,
        enableMessage: action.payload,
        enableError: null,
      };
      break;
    case ENABLE_USER_FAILED:
      state = {
        ...state,
        enableMessage: null,
        loadingEnableUser: false,
        enableError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default statusUser;
